// Partial because well, GraphQL doesn't have failures
export type MembershipValue = Partial<{
  demographics: {
    isTopCard: boolean;
  };
  accountToken: string;
}>;

export const MEMBERSHIP_DOMAIN_QUERY = `
  query MembershipQuery {
    membership(id: "", type: JWT_TOKEN) {
      demographics {
        isTopCard
      }
      accountToken
    }
  }
`
